import { Button, Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import React from "react"
import { Link } from "react-router-dom"
import routes from "routes"
import { learningItemSlugs } from "utils/constants"
import { useEnrollments } from "utils/hooks/useEnrollments"
import { PropsWithClassName } from "utils/types"

import ImpactCourseLogo from "./assets/impact-course-logo.webp"

const Certificate = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33333 3.5C9.78241 3.49998 10.2219 3.62954 10.5992 3.87314C10.9765 4.11675 11.2754 4.46404 11.4602 4.87334C11.6449 5.28265 11.7076 5.73657 11.6408 6.18064C11.574 6.62471 11.3804 7.04005 11.0833 7.37683V9.82217C11.0833 9.93156 11.0554 10.0391 11.0021 10.1347C10.9489 10.2302 10.8721 10.3106 10.779 10.3681C10.686 10.4256 10.5798 10.4584 10.4705 10.4633C10.3612 10.4682 10.2525 10.4451 10.1547 10.3962L9.33333 9.9855L8.512 10.3962C8.41416 10.4451 8.30544 10.4682 8.19617 10.4633C8.08689 10.4584 7.98068 10.4256 7.88763 10.3681C7.79459 10.3106 7.71778 10.2302 7.66453 10.1347C7.61127 10.0391 7.58332 9.93156 7.58333 9.82217V7.37683C7.28627 7.04005 7.09271 6.62471 7.02586 6.18064C6.95902 5.73657 7.02174 5.28265 7.2065 4.87334C7.39126 4.46404 7.69021 4.11675 8.06747 3.87314C8.44472 3.62954 8.88426 3.49998 9.33333 3.5ZM10.5 0C10.8094 0 11.1062 0.122916 11.325 0.341709C11.5438 0.560501 11.6667 0.857248 11.6667 1.16667V2.33333C11.6667 2.48804 11.6052 2.63642 11.4958 2.74581C11.3864 2.85521 11.238 2.91667 11.0833 2.91667C10.9286 2.91667 10.7802 2.85521 10.6709 2.74581C10.5615 2.63642 10.5 2.48804 10.5 2.33333V1.16667H1.16667V8.16667H5.83333C5.98804 8.16667 6.13642 8.22813 6.24581 8.33752C6.35521 8.44692 6.41667 8.59529 6.41667 8.75C6.41667 8.90471 6.35521 9.05308 6.24581 9.16248C6.13642 9.27188 5.98804 9.33333 5.83333 9.33333H1.16667C0.857247 9.33333 0.560501 9.21042 0.341709 8.99163C0.122916 8.77283 0 8.47609 0 8.16667V1.16667C0 0.857248 0.122916 0.560501 0.341709 0.341709C0.560501 0.122916 0.857247 0 1.16667 0H10.5ZM9.91667 8.09317C9.53405 8.19196 9.13261 8.19196 8.75 8.09317V8.97283L9.07258 8.81183C9.15355 8.77138 9.24282 8.75031 9.33333 8.75031C9.42385 8.75031 9.51312 8.77138 9.59408 8.81183L9.91667 8.97283V8.09317ZM9.33333 4.66667C9.02391 4.66667 8.72717 4.78958 8.50838 5.00838C8.28958 5.22717 8.16667 5.52391 8.16667 5.83333C8.16667 6.14275 8.28958 6.4395 8.50838 6.65829C8.72717 6.87708 9.02391 7 9.33333 7C9.64275 7 9.9395 6.87708 10.1583 6.65829C10.3771 6.4395 10.5 6.14275 10.5 5.83333C10.5 5.52391 10.3771 5.22717 10.1583 5.00838C9.9395 4.78958 9.64275 4.66667 9.33333 4.66667ZM4.08333 5.25C4.23201 5.25017 4.37502 5.3071 4.48313 5.40916C4.59124 5.51123 4.6563 5.65072 4.66502 5.79915C4.67373 5.94757 4.62544 6.09372 4.53001 6.20774C4.43458 6.32175 4.29922 6.39502 4.15158 6.41258L4.08333 6.41667H2.91667C2.76799 6.4165 2.62498 6.35957 2.51687 6.25751C2.40876 6.15544 2.3437 6.01594 2.33498 5.86752C2.32627 5.7191 2.37456 5.57295 2.46999 5.45893C2.56542 5.34492 2.70078 5.27164 2.84842 5.25408L2.91667 5.25H4.08333ZM6.41667 2.91667C6.57138 2.91667 6.71975 2.97813 6.82915 3.08752C6.93854 3.19692 7 3.34529 7 3.5C7 3.65471 6.93854 3.80308 6.82915 3.91248C6.71975 4.02188 6.57138 4.08333 6.41667 4.08333H2.91667C2.76196 4.08333 2.61358 4.02188 2.50419 3.91248C2.39479 3.80308 2.33333 3.65471 2.33333 3.5C2.33333 3.34529 2.39479 3.19692 2.50419 3.08752C2.61358 2.97813 2.76196 2.91667 2.91667 2.91667H6.41667Z"
      fill="#64748B"
    />
  </svg>
)
export const ImpactProgramCard = ({ className }: PropsWithClassName) => {
  return (
    <div
      className={`h-min rounded-[12px] p-0.25 ${className}`}
      style={{
        background:
          "linear-gradient(118.49deg, #FFE159 2.28%, #B977FD 35.85%, #43BDD6 100%)",
        boxShadow: "0px 6px 15px 0px #78A4D033, 0px 1px 2px 0px #4A84BE33",
      }}
    >
      <div className="flex flex-col justify-between rounded-[12px] bg-white p-2.5">
        <div className="flex flex-col">
          <div className="flex flex-row justify-between shadow-[inset_0px_4px_12px_#FFFFFF21]">
            <img
              src={ImpactCourseLogo}
              alt="Suraasa Verified Badge"
              className="mb-1 h-4"
            />
            <div className="h-min rounded-lg bg-[#F4D7FF] px-1 py-0.5">
              <Typography
                variant={"body"}
                className="text-[10px] font-medium text-[#442768]"
              >
                Recommended
              </Typography>
            </div>
          </div>
          <Typography variant="strong" className="mb-0.25">
            IMPACT
          </Typography>
          <Typography variant="smallBody" className="mb-2.5 text-onSurface-500">
            Instructional Mastery & Pedagogy Advancement for Classroom Teaching
          </Typography>

          <div className="flex items-center justify-start gap-0.75">
            <Certificate />
            <Typography variant="smallBody" className="text-onSurface-500">
              Certificate Upon Completion
            </Typography>
          </div>
        </div>

        <Link
          to={routes.parentItem
            .replace(":learningItemType", "course")
            .replace(":slug", learningItemSlugs.impactCourse)}
          target="_blank"
        >
          <Button variant={"filled"} color="black" className="mt-2.5 w-full">
            Start Learning
          </Button>
        </Link>
      </div>
    </div>
  )
}

const NextStepImpact = () => {
  const { enrollments } = useEnrollments()
  const impactCourse = enrollments?.find(
    i => i.slug === learningItemSlugs.impactCourse
  )

  if (!impactCourse) return null

  console.log(impactCourse)
  return (
    <div className={clsx("relative mt-2")}>
      <div className="mb-2.5 flex flex-col items-start justify-between gap-3 rounded-[18px] bg-surface-100 p-3 sm:flex-row sm:items-center">
        <div className="sm:max-w-[304px]">
          <Typography variant="preTitle" className="mb-2 text-primary-500">
            NEXT STEP
          </Typography>
          <Typography variant="title3" className="mb-2 text-xl font-semibold">
            You’re all set to begin your learning journey.
          </Typography>
          <Typography variant="smallBody" className="mb-2 text-onSurface-500">
            Start your course now to build on your strengths and improve the
            areas identified in your assessment.
          </Typography>
        </div>

        <ImpactProgramCard className="w-full shrink-0 sm:w-1/2 sm:max-w-[377px]" />
      </div>
    </div>
  )
}

export default NextStepImpact
